import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './share-icons-horizontal.component.scss';
var ShareIconsHorizontal = /** @class */ (function (_super) {
    tslib_1.__extends(ShareIconsHorizontal, _super);
    function ShareIconsHorizontal(element) {
        return _super.call(this, element) || this;
    }
    ShareIconsHorizontal.prototype.init = function () {
        this.shareButton = this.element.querySelector('.js-share');
        this.shareLinks = Array.from(this.element.querySelectorAll('.share-icons-horizontal__link'));
        if (this.element.querySelector('.js-share-clipboard')) {
            this.clipboardButton = this.element.querySelector('.js-share-clipboard');
        }
        if (this.element.querySelector('.js-share-mail')) {
            this.emailButton = this.element.querySelector('.js-share-mail');
        }
        if (this.element.querySelector('.js-share-facebook')) {
            this.facebookButton = this.element.querySelector('.js-share-facebook');
        }
        if (this.element.querySelector('.js-share-twitter')) {
            this.twitterButton = this.element.querySelector('.js-share-twitter');
        }
        if (this.element.querySelector('.js-share-linkedin')) {
            this.linkedinButton = this.element.querySelector('.js-share-linkedin');
        }
        if (this.element.querySelector('.js-share-whatsapp')) {
            this.whatsButton = this.element.querySelector('.js-share-whatsapp');
        }
        this.shareUrl = encodeURIComponent(document.URL);
        this.shareTitle = '';
        this.shareDescription = '';
        this.shareImage = '';
        if (this.element.querySelector('.share__snackbar')) {
            this.shareSnackBar = this.element.querySelector('.share__snackbar');
        }
        if (this.element.querySelector('.share__snackbar--inner__close')) {
            this.shareSnackBarClose = this.element.querySelector('.share__snackbar--inner__close');
        }
        this.setShareLinks();
    };
    ShareIconsHorizontal.prototype.bindEvents = function () {
        var _this = this;
        document.addEventListener('click', function () { return _this.closeShareOnDocumentClick(event); });
        this.shareButton.addEventListener('click', function () { return _this.toggleShare(); });
        if (this.clipboardButton) {
            this.clipboardButton.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var data = element.getAttribute('data-url');
                navigator.clipboard.writeText(data);
                if (_this.shareSnackBar) {
                    _this.shareSnackBar.classList.add('active');
                    setTimeout(function () {
                        _this.shareSnackBar.classList.remove('active');
                    }, 5000);
                }
            });
        }
        if (this.shareSnackBarClose) {
            this.shareSnackBarClose.addEventListener('click', function (event) {
                if (_this.shareSnackBar) {
                    _this.shareSnackBar.classList.remove('active');
                }
            });
        }
        if (this.facebookButton) {
            this.facebookButton.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var data = element.getAttribute('data-social');
                _this.newPopup(data, 'Standard Bank');
            });
        }
        if (this.twitterButton) {
            this.twitterButton.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var data = element.getAttribute('data-social');
                _this.newPopup(data, 'Standard Bank');
            });
        }
        if (this.linkedinButton) {
            this.linkedinButton.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var data = element.getAttribute('data-social');
                _this.newPopup(data, 'Standard Bank');
            });
        }
        if (this.whatsButton) {
            this.whatsButton.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var data = element.getAttribute('data-social');
                _this.newPopup(data, 'Standard Bank');
            });
        }
        window.addEventListener('resize', function (event) {
            var windowWidth = window.screen.width;
            if (windowWidth > 767) {
                _this.whatsButton.setAttribute('data-social', "https://web.whatsapp.com/send?text=" + _this.shareUrl + "&url=" + _this.shareUrl);
            }
            else {
                _this.whatsButton.setAttribute('data-social', "whatsapp://send?text=" + _this.shareUrl + "&url=" + _this.shareUrl);
            }
        });
    };
    ShareIconsHorizontal.prototype.getShareMeta = function (meta) {
        var ogAttribute = document.querySelector("meta[property='og:" + meta + "']");
        if (ogAttribute) {
            return encodeURIComponent(ogAttribute.getAttribute('content'));
        }
        return '';
    };
    ShareIconsHorizontal.prototype.setShareMeta = function () {
        this.shareTitle = this.getShareMeta('title');
        this.shareDescription = this.getShareMeta('description');
        this.shareImage = this.getShareMeta('image');
    };
    ShareIconsHorizontal.prototype.setShareLinks = function () {
        var _this = this;
        this.setShareMeta();
        setTimeout(function () {
            if (_this.clipboardButton) {
                _this.clipboardButton.setAttribute('data-url', decodeURIComponent(_this.shareUrl));
            }
            if (_this.emailButton) {
                _this.emailButton.setAttribute('href', "mailto:?subject=" + _this.shareTitle + "&body=" + _this.shareDescription + " - " + _this.shareUrl);
            }
            if (_this.facebookButton) {
                _this.facebookButton.setAttribute('data-social', "https://www.facebook.com/dialog/share?app_id=363419304366429&display=popup&href=" + _this.shareUrl + "&redirect_uri=" + _this.shareUrl);
            }
            if (_this.twitterButton) {
                _this.twitterButton.setAttribute('data-social', "https://twitter.com/intent/tweet?url=" + _this.shareUrl + "&text=" + _this.shareDescription);
            }
            if (_this.linkedinButton) {
                _this.linkedinButton.setAttribute('data-social', "https://www.linkedin.com/shareArticle?mini=true&url=" + _this.shareUrl);
            }
            var windowWidth = window.screen.width;
            if (windowWidth > 767) {
                if (_this.whatsButton) {
                    _this.whatsButton.setAttribute('data-social', "https://web.whatsapp.com/send?text=" + _this.shareUrl + "&url=" + _this.shareUrl);
                }
            }
            else {
                if (_this.whatsButton) {
                    _this.whatsButton.setAttribute('data-social', "whatsapp://send?text=" + _this.shareUrl + "&url=" + _this.shareUrl);
                }
            }
        }, 200);
    };
    ShareIconsHorizontal.prototype.toggleShare = function () {
        if (this.facebookButton.classList.contains('share-icons-horizontal__link--open')) {
            this.closeShare();
        }
        else {
            this.openShare();
        }
    };
    ShareIconsHorizontal.prototype.toggleIcons = function (action) {
        var shareIconClosed = this.element.querySelector('.js-share-closed');
        var shareIconOpened = this.element.querySelector('.js-share-opened');
        var shareIconLinks = this.element.querySelector('.share-icons-horizontal__links');
        if (action === 'open') {
            shareIconLinks.classList.add('share-icons-horizontal__links--opened');
            shareIconClosed.classList.add('share__button-icon--hidden');
            shareIconOpened.classList.remove('share__button-icon--hidden');
        }
        else {
            shareIconLinks.classList.remove('share-icons-horizontal__links--opened');
            shareIconOpened.classList.add('share__button-icon--hidden');
            shareIconClosed.classList.remove('share__button-icon--hidden');
        }
    };
    ShareIconsHorizontal.prototype.closeShareOnDocumentClick = function (event) {
        var targetElement = event.target;
        do {
            if (targetElement === this.element) {
                return;
            }
            targetElement = targetElement.parentNode;
        } while (targetElement);
        this.closeShare();
    };
    ShareIconsHorizontal.prototype.openShare = function () {
        this.toggleIcons('open');
        var timeoutDelay = 0;
        this.shareLinks.forEach(function (shareLink) {
            setTimeout(function () {
                shareLink.classList.add('share-icons-horizontal__link--open');
            }, timeoutDelay);
            timeoutDelay += 50;
        });
    };
    ShareIconsHorizontal.prototype.closeShare = function () {
        this.toggleIcons('close');
        var timeoutDelay = 0;
        var shareLinksClone = this.shareLinks.slice().reverse();
        shareLinksClone.forEach(function (shareLink) {
            setTimeout(function () {
                shareLink.classList.remove('share-icons-horizontal__link--open');
            }, timeoutDelay);
            timeoutDelay += 100;
        });
    };
    ShareIconsHorizontal.prototype.newPopup = function (url, windowName) {
        window.open(url, windowName, 'height=500,width=500,left=10,top=10,titlebar=no,toolbar=no,menubar=no,location=no,directories=no,status=no');
    };
    return ShareIconsHorizontal;
}(Base));
export { ShareIconsHorizontal };



//////////////////
// WEBPACK FOOTER
// ./components/share-icons-horizontal/share-icons-horizontal.component.ts
// module id = 500
// module chunks = 0